export interface EcommerceModifiedProduct {
  currency: string;
  value: number;
  items: Array<EcommerceProductItem>
}

export interface EcommerceCartAllProduct {
  currency: string;
  value: number;
  coupon: string;
  items: Array<EcommerceProductItem>
}

export interface ProductItem {
  name: string;
  id: string;
  price: string;
  brand: string;
  category: string;
  variant: string;
  quantity: number;
  coupon?: string;
}

export enum EcommerceType {
  ADD = 'add',
  REMOVE = 'remove',
  ADD_TO_CART = 'add_to_cart',
  REMOVE_FROM_CART = 'remove_from_cart',
  VIEW_CART = 'view_cart',
  VIEW_PROMOTION = 'view_promotion',
  SELECT_PROMOTION = 'select_promotion'
}

export interface EcommerceProductItemDetail {
  item_name: string;
  item_id: string;
  item_brand: string;
  item_category: string;
  item_category2: string;
  item_list_id?: string;
  item_list_name?: string;
  item_variant: string;
  price: number;
  discount: number;
}

export interface EcommerceProductItem extends EcommerceProductItemDetail {
  index?: string;
  quantity: number;
  coupon?: string;
}

export interface ProductCartItemPromotionData {
  coupon: string;
  discount: number;
}
